import useSWRImmutable from "swr/immutable";
// @ts-expect-error pure js
import useAuthenticatedAxios from "./use-authenticated-axios";
import { type AxiosInstance } from "axios";
import useResources from "./use-resources";

export interface AutoAction {
  id: number;
  nom: string;
  static_id: string;
  commentaires?: string;
}

export interface AutoActionAssociation {
  id: number;
  nom_auto_action: string;
  action_date?: string;
}

interface UseAutoActionsReturn {
  autoActions: AutoAction[];
  error: Error | undefined;
  isLoading: boolean;
}

export default function useAutoActions(): UseAutoActionsReturn {
  const axios: AxiosInstance = useAuthenticatedAxios();
  const {
    data: autoActions,
    error,
    isLoading,
  } = useSWRImmutable<AutoAction[]>("auto-actions", (url: string) => {
    return axios.get(url).then((res) => res.data);
  });

  return {
    autoActions: autoActions || [],
    error,
    isLoading,
  };
}

export function useProfileBailleurAutoActions(profileId?: number) {
  const {
    resources: profileBailleurAutoActions,
    resourcesById: profileBailleurAutoActionsByName,
    error,
    isLoading,
    create,
    update,
    del,
    mutate,
  } = useResources<AutoActionAssociation>(
    profileId ? `profiles/${profileId}/auto-actions` : null,
    {},
    { groupBy: { attr: "nom_auto_action", unique: true } },
  );

  return {
    profileBailleurAutoActions,
    profileBailleurAutoActionsByName:
      profileBailleurAutoActionsByName as Record<string, AutoActionAssociation>,
    error,
    isLoading,
    createProfileBailleurAutoAction: create,
    deleteProfileBailleurAutoAction: del,
    updateProfileBailleurAutoAction: update,
    refresh: () => mutate(),
  };
}
